export const FETCH_PRODUCTS_QUERY_KEY = 'fetchProducts'
export const FETCH_PRODUCT_INVENTORY_QUERY_KEY = 'fetchProductInventory'
export const FETCH_INVENTORY_QUERY_KEY = 'fetchInventory'